/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 东艺查询演出
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  month: number,
  year: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.DongYiHolidaysDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/theater/dongyi-products/${year}/${month}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
